import { Injectable } from '@angular/core';
import { getCookie, setCookie, removeCookie } from '../lib/cookies';
import { CookieKey } from '@lib/cookie-keys.const';
import isPlainObject from 'lodash/isPlainObject';

const COOKIE: CookieKey = CookieKey.DASHBOARD_STORAGE;

@Injectable({ providedIn: 'root' })
export class SessionStorage {
  private _data;

  constructor() {
    this._data = this._getCookie();
  }

  public getKey(key) {
    return this._data[key];
  }

  public setKey(key, value) {
    this._data[key] = value;
    this._setCookie(this._data);
  }

  public removeCookie(): void {
    removeCookie(COOKIE);
  }

  private _getCookie() {
    let data;
    try {
      data = JSON.parse(getCookie(COOKIE));
      data = isPlainObject(data) ? data : {};
    } catch (e) {
      data = {};
      this._setCookie(data);
    }
    return data;
  }

  private _setCookie(data) {
    setCookie(COOKIE, data);
  }

}
